// submitFeedsPin.js
'use strict';
import 'isomorphic-fetch';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import getMeData from '../selector/getMeData.js';

import fetchFeeds from '../action/fetchFeeds.js';
import pushToastr from '../action/pushToastr.js';

import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';
import getTranslationKey from '../resource/getTranslationKey.js';

import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Submit feeds pin
 * @kind action
 * @param {string} {id} - be pinned item id.
 * @param {string} {feedAlias} - feed alias that item be pinned.
 * @return {Promise} Action promise.
 */
const submitFeedsPin =
  ({ id, feedAlias } = {}) =>
  async (dispatch, getState) => {
    const networkingSelectPath = ['submit', 'feeds', feedAlias, 'pin', id];
    const token = getMeData(getState(), 'token');
    if (!token || !id || !feedAlias) {
      return dispatch({ type: '' });
    }
    const fetchOptions = {
      method: 'POST',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        item_id: id,
      }),
    };
    const fetchUrl = getResourceUrl({ endpoint: `/feeds/${feedAlias}/pin` });
    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);
      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl,
        });
      }
      dispatch(
        pushToastr({
          textKey: 'message_pinned',
        })
      );
      const nowUnix = getCurrentUnixTimestamp();
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['profileFeed'],
          data: {
            unixTimestamp: nowUnix,
          },
        },
      });
      dispatch(
        fetchFeeds({
          type: feedAlias,
          page: 1,
          shouldSkipLocalCache: true,
        })
      );
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      let errorObject = {};
      try {
        errorObject = JSON.parse(error.message);
        // eslint-disable-next-line no-empty
      } catch (_) {}
      if (errorObject.code) {
        const errorI18nKey = getTranslationKey({
          key: `error_${errorObject.code}`,
        });
        dispatch(
          pushToastr({
            textKey: errorI18nKey,
            color: 'error',
          })
        );
      }
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default submitFeedsPin;
